import React from "react";

import Layout from "../components/Layout";
import FarmCard from "../components/Farm/FarmCard";

export default function Lend() {
  return (
    <Layout>
      <div className="w-full flex flex-col items-center justify-center space-y-10">
        <FarmCard />
        <FarmCard />
        <FarmCard />
      </div>
    </Layout>
  );
}

// export default function Lend() {
//   return (
//     <Layout>
//       <div className="w-full flex flex-col items-center justify-center space-y-20">
//           <Header />
//           <div className="w-full">
//               <span className="text-lg font-bold mb-10 w-full">Dao Pools</span>
//               <div className="w-full rounded-md mt-6 flex flex-row items-center justify-between overflow-y-auto">
//                   <div className="flex flex-col items-center py-10 w-[32%] bg-white rounded-md shadow-md">
//                       <Avatar src="https://www.gravatar.com/avatar/HASH" size={40} />
//                       <div className="flex flex-row space-x-2 mt-4 items-center">
//                           <span className="text-xl font-bold">Last 30 day</span>
//                           <img src={Link_img} alt="" className="w-4 -mb-1" />
//                       </div>
//                       <div className="flex flex-row items-center justify-center mt-10 w-full px-10 space-x-2">
//                           <div className="flex-1 flex flex-col space-y-10 items-center">
//                               <div className='flex flex-col'>
//                                   <span className='text-xl font-semibold block text-center'>1.2807K</span>
//                                   <span className='text-xs text-text-black font-medium block text-center mt-2'>Total Locked</span>
//                               </div>
//                               <div className='flex flex-col'>
//                                   <span className='text-xl font-semibold block text-center text-[#FF0000]'>Over</span>
//                                   <span className='text-xs text-text-black font-medium block text-center mt-2'>Remaining</span>
//                               </div>
//                               <button className='bg-text-blur text-white text-base font-semibold py-2 w-full rounded-full'>Unlock</button>
//                           </div>
//                           <div className="flex-1 flex flex-col space-y-10 items-center">
//                               <div className='flex flex-col'>
//                                   <span className='text-xl font-semibold block text-center'>0.0000</span>
//                                   <span className='text-xs text-text-black font-medium block text-center mt-2'>My Locked</span>
//                               </div>
//                               <div className='flex flex-col'>
//                                   <span className='text-xl font-semibold block text-center'>0.00 USDT</span>
//                                   <span className='text-xs text-text-black font-medium block text-center mt-2'>Reward</span>
//                               </div>
//                               <button className='bg-text-blur bg-opacity-25 text-text-blur text-base font-semibold py-2 w-full rounded-full'>Claim</button>
//                           </div>
//                       </div>
//                   </div>
//                   <div className="flex flex-col items-center py-10 w-[32%] bg-white rounded-md shadow-md">
//                       <Avatar src="https://www.gravatar.com/avatar/HASH" size={40} />
//                       <div className="flex flex-row space-x-2 mt-4 items-center">
//                           <span className="text-xl font-bold">Last 30 day</span>
//                           <img src={Link_img} alt="" className="w-4 -mb-1" />
//                       </div>
//                       <div className="flex flex-row items-center justify-center mt-10 w-full px-10 space-x-2">
//                           <div className="flex-1 flex flex-col space-y-10 items-center">
//                               <div className='flex flex-col'>
//                                   <span className='text-xl font-semibold block text-center'>1.2807K</span>
//                                   <span className='text-xs text-text-black font-medium block text-center mt-2'>Total Locked</span>
//                               </div>
//                               <div className='flex flex-col'>
//                                   <span className='text-xl font-semibold block text-center text-[#FF0000]'>Over</span>
//                                   <span className='text-xs text-text-black font-medium block text-center mt-2'>Remaining</span>
//                               </div>
//                               <button className='bg-text-blur text-white text-base font-semibold py-2 w-full rounded-full'>Unlock</button>
//                           </div>
//                           <div className="flex-1 flex flex-col space-y-10 items-center">
//                               <div className='flex flex-col'>
//                                   <span className='text-xl font-semibold block text-center'>0.0000</span>
//                                   <span className='text-xs text-text-black font-medium block text-center mt-2'>My Locked</span>
//                               </div>
//                               <div className='flex flex-col'>
//                                   <span className='text-xl font-semibold block text-center'>0.00 USDT</span>
//                                   <span className='text-xs text-text-black font-medium block text-center mt-2'>Reward</span>
//                               </div>
//                               <button className='bg-text-blur bg-opacity-25 text-text-blur text-base font-semibold py-2 w-full rounded-full'>Claim</button>
//                           </div>
//                       </div>
//                   </div>
//                   <div className="flex flex-col items-center py-10 w-[32%] bg-white rounded-md shadow-md">
//                       <Avatar src="https://www.gravatar.com/avatar/HASH" size={40} />
//                       <div className="flex flex-row space-x-2 mt-4 items-center">
//                           <span className="text-xl font-bold">Last 30 day</span>
//                           <img src={Link_img} alt="" className="w-4 -mb-1" />
//                       </div>
//                       <div className="flex flex-row items-center justify-center mt-10 w-full px-10 space-x-2">
//                           <div className="flex-1 flex flex-col space-y-10 items-center">
//                               <div className='flex flex-col'>
//                                   <span className='text-xl font-semibold block text-center'>1.2807K</span>
//                                   <span className='text-xs text-text-black font-medium block text-center mt-2'>Total Locked</span>
//                               </div>
//                               <div className='flex flex-col'>
//                                   <span className='text-xl font-semibold block text-center text-[#FF0000]'>Over</span>
//                                   <span className='text-xs text-text-black font-medium block text-center mt-2'>Remaining</span>
//                               </div>
//                               <button className='bg-text-blur text-white text-base font-semibold py-2 w-full rounded-full'>Unlock</button>
//                           </div>
//                           <div className="flex-1 flex flex-col space-y-10 items-center">
//                               <div className='flex flex-col'>
//                                   <span className='text-xl font-semibold block text-center'>0.0000</span>
//                                   <span className='text-xs text-text-black font-medium block text-center mt-2'>My Locked</span>
//                               </div>
//                               <div className='flex flex-col'>
//                                   <span className='text-xl font-semibold block text-center'>0.00 USDT</span>
//                                   <span className='text-xs text-text-black font-medium block text-center mt-2'>Reward</span>
//                               </div>
//                               <button className='bg-text-blur bg-opacity-25 text-text-blur text-base font-semibold py-2 w-full rounded-full'>Claim</button>
//                           </div>
//                       </div>
//                   </div>
//               </div>
//           </div>
//           <div className="w-full">
//               <span className="text-lg font-bold mb-10 w-full">Dao Pools</span>
//               <div className="w-full rounded-md mt-6 flex flex-row items-center space-x-10 overflow-y-auto">
//                   <div className="flex flex-col items-center py-10 w-[32%] bg-white rounded-md shadow-md">
//                       <Avatar src="https://www.gravatar.com/avatar/HASH" size={40} />
//                       <div className="flex flex-row space-x-2 mt-4 items-center">
//                           <span className="text-xl font-bold">Last 30 day</span>
//                           <img src={Link_img} alt="" className="w-4 -mb-1" />
//                       </div>
//                       <div className="flex flex-row items-center justify-center mt-10 w-full px-10 space-x-2">
//                           <div className="flex-1 flex flex-col space-y-10 items-center">
//                               <div className='flex flex-col'>
//                                   <span className='text-xl font-semibold block text-center'>1.2807K</span>
//                                   <span className='text-xs text-text-black font-medium block text-center mt-2'>Total Locked</span>
//                               </div>
//                               <div className='flex flex-col'>
//                                   <span className='text-xl font-semibold block text-center'>0.0000</span>
//                                   <span className='text-xs text-text-black font-medium block text-center mt-2'>Earn Rewards</span>
//                               </div>
//                               <button className='bg-text-blur text-white text-base font-semibold py-2 w-full rounded-full'>Unlock</button>
//                           </div>
//                           <div className="flex-1 flex flex-col space-y-10 items-center">
//                               <div className='flex flex-col'>
//                                   <span className='text-xl font-semibold block text-center'>0.0000</span>
//                                   <span className='text-xs text-text-black font-medium block text-center mt-2'>My Locked</span>
//                               </div>
//                               <div className='flex flex-col'>
//                                   <span className='text-xl font-semibold block text-center'>0.00 USDT</span>
//                                   <span className='text-xs text-text-black font-medium block text-center mt-2'>Reward</span>
//                               </div>
//                               <button className='bg-text-blur bg-opacity-25 text-text-blur text-base font-semibold py-2 w-full rounded-full'>Claim</button>
//                           </div>
//                       </div>
//                   </div>
//               </div>
//           </div>
//       </div>
//     </Layout>
//   )
// }
